import ApiService from "@/core/services/ApiService";
import JwtService from "@/core/services/JwtService";
import { Actions, Mutations } from "@/store/enums/StoreEnums";
import { Module, Action, Mutation, VuexModule } from "vuex-module-decorators";

export interface PublicationsManages {
  name: string;
  api_token: string;
}

export interface PublicationsManagesListInfor {
  errors: unknown;
  publicationsManages: PublicationsManages;
  isAuthenticated: boolean;
}

@Module
export default class PublicationsManagesModule
  extends VuexModule
  implements PublicationsManagesListInfor
{
  errors = {};
  publicationsManages = {} as PublicationsManages;
  isAuthenticated = !!JwtService.getToken();

  get PublicationsManages() {
    return this.publicationsManagesListData;
  }

  @Mutation
  [Mutations.PUBLICATIONS_MANAGES_LIST_DATA](PublicationsManages) {
    this.publicationsManagesListData = PublicationsManages;
  }

  @Action
  [Actions.PUBLICATIONS_MANAGES_LIST](payload) {
    if (JwtService.getToken()) {
      ApiService.setHeader();
      return ApiService.post("/publications", payload)
        .then((data) => {
          this.context.commit(Mutations.PUBLICATIONS_MANAGES_LIST_DATA, data);
        })
        .catch(({ response }) => {
          this.context.commit(Mutations.PURE_AUTH_AND_SET_ERROR, response.data);
        });
    } else {
      this.context.commit(Mutations.PURGE_AUTH);
    }
  }

  @Action
  [Actions.PUBLICATIONS_MANAGE_CREATE](payload) {
    if (JwtService.getToken()) {
      ApiService.setHeader();
      return ApiService.post("publications/upsert", payload)
        .then((data) => {
          this.context.commit(Mutations.PUBLICATIONS_MANAGES_LIST_DATA, data);
          this.context.commit(Mutations.SET_ERROR, {});
        })
        .catch(({ response }) => {
          this.context.commit(Mutations.PURE_AUTH_AND_SET_ERROR, response.data);
        });
    } else {
      this.context.commit(Mutations.PURGE_AUTH);
    }
  }

  @Action
  [Actions.PUBLICATIONS_MANAGE_UPDATE](payload) {
    const id = payload.get("id");
    if (JwtService.getToken()) {
      ApiService.setHeader();
      return ApiService.getDataDetail("/publications", "upsert", id, payload)
        .then((data) => {
          this.context.commit(Mutations.PUBLICATIONS_MANAGES_LIST_DATA, data);
          this.context.commit(Mutations.SET_ERROR, {});
        })
        .catch(({ response }) => {
          this.context.commit(Mutations.PURE_AUTH_AND_SET_ERROR, response.data);
        });
    } else {
      this.context.commit(Mutations.PURGE_AUTH);
    }
  }

  @Action
  [Actions.PUBLICATIONS_MANAGE_DELETE](payload) {
    if (JwtService.getToken()) {
      ApiService.setHeader();
      return ApiService.getDataDetail(
        "/publications",
        payload,
        "delete",
        payload
      )
        .then((data) => {
          this.context.commit(Mutations.PUBLICATIONS_MANAGES_LIST_DATA, data);
        })
        .catch(({ response }) => {
          this.context.commit(Mutations.PURE_AUTH_AND_SET_ERROR, response.data);
        });
    } else {
      this.context.commit(Mutations.PURGE_AUTH);
    }
  }
}
